class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.searchBar = this.querySelector(".search-bar-fixed");
    this.input = this.querySelector("#predictive-search-input");
    this.resultsWrapper = this.querySelector(
      ".predictive-search-results-wrapper",
    );
    this.resultsContainer = this.querySelector("#predictive-search-results");
    this.closeBtn = this.querySelector(".search-bar-close-button");
    this.overlay = document.querySelector(".search-bar-overlay");
    this.debouncedOnInput = this.debounce((event) => {
      this.onChange(event);
    }, 300);
  }

  connectedCallback() {
    this.input.addEventListener("input", this.onInput.bind(this));
    this.closeBtn.addEventListener("click", this.closeSearchBar.bind(this));

    document.querySelectorAll(".search-btn").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.openSearchBar();
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener("click", this.closeSearchBar.bind(this));
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeSearchBar();
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onInput(event) {
    const query = event.target.value.trim();
    if (query.length > 0) {
      this.resultsWrapper.classList.add("open");
      this.resultsWrapper.classList.add("loading");
    } else {
      this.closeResults();
    }
    this.debouncedOnInput(event);
  }

  onChange(event) {
    const query = event.target.value.trim();
    if (!query) {
      this.closeResults();
      return;
    }
    this.fetchResults(query);
  }

  async fetchResults(query) {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query,
        )}&resources[type]=product&resources[limit]=5&section_id=predictive-search`,
      );
      const data = await response.json();
      this.renderResults(data.resources.results.products, query);
    } catch (e) {
      console.error("Predictive Search Error:", e);
      this.resultsWrapper.classList.remove("loading");
    }
  }

  highlightText(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(
      regex,
      '<span class="predictive-search-highlight">$1</span>',
    );
  }

  renderResults(products, query) {
    this.resultsContainer.innerHTML = "";
    this.resultsWrapper.classList.remove("loading");

    if (products && products.length > 0) {
      products.forEach((product) => {
        const item = document.createElement("a");
        item.href = product.url;
        item.className = "predictive-search-item";

        let imageHtml = "";
        if (product.image) {
          imageHtml = `
              <div class="predictive-search-item__image-container">
                <img src="${product.image}" class="predictive-search-item__image" alt="${product.title}">
              </div>
            `;
        }

        item.innerHTML = `
            ${imageHtml}
            <div class="predictive-search-item__content">
              <div class="predictive-search-item__title">
                ${this.highlightText(product.title, query)}
              </div>
              <div class="predictive-search-item__description label-m">
                ${this.highlightText(product.price, query)}
              </div>
            </div>
          `;
        this.resultsContainer.appendChild(item);
      });
      this.openResults();
    } else {
      this.resultsContainer.innerHTML =
        '<div class="predictive-search-no-results">No items found</div>';
      this.openResults();
    }
  }

  openResults() {
    this.resultsWrapper.classList.add("open");
  }

  closeResults() {
    this.resultsWrapper.classList.remove("open");
    this.resultsWrapper.classList.remove("loading");
    setTimeout(() => {
      if (!this.resultsWrapper.classList.contains("open")) {
        this.resultsContainer.innerHTML = "";
      }
    }, 300);
  }

  openSearchBar() {
    this.searchBar.classList.add("open");
    if (this.overlay) this.overlay.classList.add("open");
    this.input.focus();
    document.body.classList.add("overflow-hidden");
  }

  closeSearchBar() {
    this.searchBar.classList.remove("open");
    if (this.overlay) this.overlay.classList.remove("open");
    this.input.value = "";
    this.closeResults();
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("predictive-search", PredictiveSearch);
